import axios from 'axios'
import jwtDecode from 'jwt-decode'

export const setAuthToken = token => {
  if (token) {
    // Apply authorization token to every request if logged in
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
  } else {
    // Delete auth header
    delete axios.defaults.headers.common['Authorization']
  }
}

export const isCorrectProject = () => {
  const token = localStorage.getItem('token')
  const decoded = jwtDecode(token)

  return (
    decoded.hasOwnProperty('roleList') &&
    decoded.roleList.length > 0 &&
    decoded.roleList.some(el => el.project.code === 'SUPPORT_ADMIN')
  )
}

export const accesses = (roles, t) => {
  const token = !!t ? t : localStorage.getItem('token')

  if (!!token && token !== null && !!roles) {
    return jwtDecode(token).roleList.some(
      item =>
        item?.project?.code === 'SUPPORT_ADMIN' && roles.includes(item.code)
    )
  } else {
    return false
  }
}

export const width = () => {
  const d = document.documentElement
  return window.innerWidth || d.clientWidth
}

export const isMobile = () => width() <= 550
